const ZENDESK_SCRIPT_ID = 'ze-snippet'

function getZendeskKey(config = {}) {
  const raw = config?.key
  return typeof raw === 'string' ? raw.trim() : ''
}

export function initZendesk(config = {}) {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return Promise.resolve(false)
  }

  const key = getZendeskKey(config)
  if (!key) {
    console.warn('[ZendeskService] Missing Zendesk key in support chat config.')
    return Promise.resolve(false)
  }

  // If widget already loaded or script exists, treat as initialized.
  if (typeof window.zE === 'function') return Promise.resolve(true)
  const existingScript = document.getElementById(ZENDESK_SCRIPT_ID)
  if (existingScript) return Promise.resolve(true)

  // Optional runtime settings
  window.zESettings = window.zESettings || {}
  if (typeof config.locale === 'string' && config.locale.trim()) {
    window.zESettings.webWidget = window.zESettings.webWidget || {}
    window.zESettings.webWidget.locale = config.locale.trim()
  }

  return new Promise((resolve) => {
    const script = document.createElement('script')
    script.id = ZENDESK_SCRIPT_ID
    script.async = true
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${encodeURIComponent(key)}`
    script.onload = () => resolve(true)
    script.onerror = () => {
      console.warn('[ZendeskService] Failed to load Zendesk widget script.')
      resolve(false)
    }
    document.head.appendChild(script)
  })
}

export async function openZendesk(config = {}) {
  const ready = await initZendesk(config)
  if (!ready || typeof window === 'undefined') return

  const tryOpen = () => {
    let attempted = false
    try {
      // Newer widget API
      window.zE?.('messenger', 'open')
      attempted = true
    } catch (e) {
      // ignore
    }
    try {
      // Legacy web widget API
      window.zE?.('webWidget', 'open')
      attempted = true
    } catch (e) {
      // ignore
    }
    if (!attempted) {
      console.warn('[ZendeskService] Could not open Zendesk widget.')
    }
  }

  // Run immediately and retry briefly in case widget API is not ready yet.
  tryOpen()
  setTimeout(tryOpen, 350)
  setTimeout(tryOpen, 1000)
}

export function hideZendesk() {
  if (typeof window === 'undefined') return
  try {
    window.zE?.('messenger', 'hide')
  } catch (e) {
    // ignore
  }
  try {
    window.zE?.('webWidget', 'hide')
  } catch (e) {
    // ignore
  }
}

export function showZendesk() {
  if (typeof window === 'undefined') return
  try {
    window.zE?.('messenger', 'show')
  } catch (e) {
    // ignore
  }
  try {
    window.zE?.('webWidget', 'show')
  } catch (e) {
    // ignore
  }
}
